import styled from "styled-components";
import { SectionHeading, SectionContent } from "../config/StyledComponents";
import { Colors } from "../config";

const SectionHeaderAndContent = ({
  heading,
  content,
  headerFontSize,
  headerFontWeight,
  contentFontSize,
  contentFontWeight,
  textTransform,
  contentFontColor = Colors.shark,
  onClick,
}) => {
  return (
    <>
      {/* {heading === "Phone" && content ? null : ( */}
        <BoxTabEach>
          <SectionHeading
            fontSize={headerFontSize}
            fontWeight={headerFontWeight}
          >
            {heading}
          </SectionHeading>
          <SectionContent
            fontSize={contentFontSize}
            fontWeight={contentFontWeight}
            fontColor={contentFontColor}
            textTransform={textTransform}
            onClick={onClick ? onClick : undefined}
          >
            {content}
          </SectionContent>
        </BoxTabEach>
      {/* )} */}
    </>
  );
};

const BoxTabEach = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 16.563rem;
`;

export default SectionHeaderAndContent;
